/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AppInfoResponse } from '../model';
/**
 * AppInfoApi - axios parameter creator
 * @export
 */
export const AppInfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This returns general information like minimum OS version, minimum App version, etc.
         * @summary General App Information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppInfo: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/app_info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppInfoApi - functional programming interface
 * @export
 */
export const AppInfoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppInfoApiAxiosParamCreator(configuration)
    return {
        /**
         * This returns general information like minimum OS version, minimum App version, etc.
         * @summary General App Information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppInfo(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppInfo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AppInfoApi - factory interface
 * @export
 */
export const AppInfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppInfoApiFp(configuration)
    return {
        /**
         * This returns general information like minimum OS version, minimum App version, etc.
         * @summary General App Information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppInfo(options?: any): AxiosPromise<AppInfoResponse> {
            return localVarFp.getAppInfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppInfoApi - interface
 * @export
 * @interface AppInfoApi
 */
export interface AppInfoApiInterface {
    /**
     * This returns general information like minimum OS version, minimum App version, etc.
     * @summary General App Information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppInfoApiInterface
     */
    getAppInfo(options?: AxiosRequestConfig): AxiosPromise<AppInfoResponse>;

}

/**
 * AppInfoApi - object-oriented interface
 * @export
 * @class AppInfoApi
 * @extends {BaseAPI}
 */
export class AppInfoApi extends BaseAPI implements AppInfoApiInterface {
    /**
     * This returns general information like minimum OS version, minimum App version, etc.
     * @summary General App Information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppInfoApi
     */
    public getAppInfo(options?: AxiosRequestConfig) {
        return AppInfoApiFp(this.configuration).getAppInfo(options).then((request) => request(this.axios, this.basePath));
    }
}
